import { message } from "antd";

function employeeErrorLogs(errorData, errorMsg) {
  if (errorData.response.status === 400 && errorData.response.data) {
    const errors = [];

    // unique fields validation
    const uniqueFields = {
      employee_code: "Código",
      email: "E-mail",
      phone_number: "Número de telefone",
    };

    const repeatedFields = [];
    for (let field of Object.keys(uniqueFields))
      if (field in errorData.response.data)
        repeatedFields.push(uniqueFields[field]);

    if (repeatedFields.length > 0)
      errors.push(
        "O(s) seguinte(s) campo(s) já está(ão) sendo utilizado(s) por outro(s) funcionário(s): " +
          repeatedFields.join(", "),
      );

    // inactive relations validation
    const relationFields = {
      manager: "Gestor",
      area: "Área",
      position: "Cargo",
    };
    const inactiveRelations = [];
    for (let field of Object.keys(relationFields))
      if (field in errorData.response.data)
        inactiveRelations.push(relationFields[field]);

    if (inactiveRelations.length > 0)
      errors.push(
        "A(s) seguinte(s) relação(ões) não está(ão) ativa(s) durante a data de contratação: " +
          inactiveRelations.join(", "),
      );

    // invalid fields validation
    const fieldsToBeValidated = {
      cpf: "cpf",
    };

    for (let field of Object.keys(fieldsToBeValidated)) {
      if (field in errorData.response.data) {
        errors.push(errorData.response.data[field][0]);
      }
    }

    // TODO: add new validations here

    message.error(errors.join("\n"));
  } else {
    message.error(errorMsg);
  }
}

export function createEmployeeErrorLogs(errorData) {
  employeeErrorLogs(
    errorData,
    "Não foi possível realizar a solicitação de criação de funcionário",
  );
}

export function editEmployeeErrorLogs(errorData) {
  employeeErrorLogs(
    errorData,
    "Não foi possível realizar a solicitação de edição de funcionário",
  );
}
